import { Exclude, Expose, Transform, Type } from 'class-transformer';
import { AddressSubType, AddressType } from '../type';
import { BaseModel, CountryModel } from '@core/data-access';
import { ForeignAddress, IAddress, LocalAddress } from '../interface';
import { Default } from '@core/util';
import { formatSingaporeAddress } from '../util';

@Exclude()
export class AddressAttrs {
  @Expose() differentResidential!: boolean;
}

@Exclude()
export class LocalAddressModel extends BaseModel implements LocalAddress {
  @Expose() postalCode!: string;
  @Expose() blockNumber!: string;
  @Expose() streetName!: string;
  @Expose() buildingName!: string;
  @Expose() storey!: string;
  @Expose() unitNumber!: string;
}

@Exclude()
export class ForeignAddressModel extends BaseModel implements ForeignAddress {
  @Expose() addressLine1!: string;
  @Expose() addressLine2!: string;
  @Expose() countryId!: number;
}

@Exclude()
export class AddressModel extends BaseModel implements LocalAddress, IAddress {
  /**
   * Primary ID
   *
   * Null when create
   */
  @Expose() @Default(null) id?: number | null;
  @Expose() type!: AddressType;
  @Expose() subType!: AddressSubType;
  @Expose() postalCode!: string;
  @Expose() blockNumber!: string;
  @Expose() streetName!: string;
  @Expose() buildingName!: string;
  @Expose() storey!: string;
  @Expose() unitNumber!: string;
  @Expose() addressLine1!: string;
  @Expose() addressLine2!: string;
  @Expose() countryId?: number;
  @Expose({ toClassOnly: true }) country?: CountryModel;
  @Expose() @Type(() => AddressAttrs) attrs!: AddressAttrs;

  @Expose({ toClassOnly: true })
  @Transform(({ obj }) => {
    if (obj['splittedAddress']) {
      return obj['splittedAddress'];
    }

    return formatSingaporeAddress(obj);
  })
  splittedAddress!: string;
}
